import type { TemplateResult } from "lit";
import { html } from "lit";

export function renderStoreFooter(): TemplateResult {
  return html`
    <div class="store-footer">
      <section class="store-section">
        <svg class="store-icon" viewBox="0 0 24 24">
          <path
            d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm-1-13h2v6h-2zm0 8h2v2h-2z"
          />
        </svg>
        <h3 class="store-title">How may we help?</h3>
        <p class="store-text">
          Looking for something specific? Have questions about a resource? We're
          eager to help. Please contact us using the
          <a href="https://lc.chat/now/7423931/">chat bubble</a>,
          <a href="mailto:service@ligonier.org">email</a>, or calling
          <a href="tel:+1-800-435-4343">800-435-4343</a>.
        </p>
      </section>
    </div>
  `;
}
